var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"p-12 text-center"},[_c('Loader')],1):_c('div',[_c('VHeader',{attrs:{"project":_vm.project}}),_c('VNavigation'),_c('div',{staticClass:"p-4 lg:p-12"},[_c('div',{staticClass:"max-w-7xl mx-auto"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }